(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation_fixed"] && !Shopify.designMode) return;
  try {
    
class NavigationFixed extends HTMLElement {
  constructor() {
    super();
    this.navItems = [];
    this.targetElements = [];
    this.headerHeight = 0;
    this.ownHeight = 0;
    this.scrollTimeout = null;
    
    // Bind event handlers
    this.handleNavClick = this.handleNavClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  init() {
    this.calculateHeaderHeight();
    this.updatePosition();
    this.findTargetElements();
    this.renderNavItems();
    this.addEventListeners();
    this.handleScroll();
  }

  calculateHeaderHeight() {
    const styles = getComputedStyle(document.documentElement);
    this.headerHeight = (parseInt(styles.getPropertyValue('--header-top-height')) || 0);
  }

  updatePosition() {
    this.style.top = this.headerHeight + 'px';
    this.ownHeight = parseInt(getComputedStyle(document.querySelector('.navigation_fixed')).height) || 0;
  }

  findTargetElements() {
    this.targetElements = Array.from(document.querySelectorAll('[navigation-title]'));
  }

  renderNavItems() {
    const navBox = this.querySelector('.q_pageBox-box');
    const navSection = document.querySelector('.navigation_fixed');
    const leftImage = navBox.querySelector('.nav-left-image');
    if (!navBox || this.targetElements.length === 0) return;

    const html = this.targetElements.map(el => {
      const title = el.getAttribute('navigation-title');
      return title ? `<span data-nav-index>${title}</span>` : '';
    }).join('');

    if (html) {
      navBox.innerHTML = '';
      if (leftImage) {
        navBox.appendChild(leftImage);
      }
      navBox.insertAdjacentHTML('beforeend', html);
      if (navSection) {
        navSection.classList.add('active');
      }
      this.navItems = Array.from(navBox.querySelectorAll('span[data-nav-index]'));
    }
  }

  addEventListeners() {
    this.navItems.forEach(item => {
      item.addEventListener('click', this.handleNavClick);
    });
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  removeEventListeners() {
    this.navItems.forEach(item => {
      item.removeEventListener('click', this.handleNavClick);
    });
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    
    this.scrollTimeout = setTimeout(() => {
      this.updateActiveState();
    }, 100);
  }

  updateActiveState() {
    if (this.targetElements.length === 0) return;
    
    // const scrollPosition = window.scrollY + this.headerHeight + this.ownHeight + 100;
    const scrollPosition = window.scrollY + this.ownHeight + 100;
    let activeIndex = 0;
    
    for (let i = 0; i < this.targetElements.length; i++) {
      const elementTop = this.getElementTop(this.targetElements[i]);
      if (elementTop <= scrollPosition) {
        activeIndex = i;
      }
    }
    
    this.setActiveItem(activeIndex);
  }

  handleNavClick(event) {
    this.calculateHeaderHeight();
    this.updatePosition();

    const index = this.navItems.indexOf(event.currentTarget);
    if (index === -1 || !this.targetElements[index]) return;

    // const targetTop = this.getElementTop(this.targetElements[index]) - this.ownHeight - this.headerHeight;
    const targetTop = this.getElementTop(this.targetElements[index]) - this.ownHeight;
    this.setActiveItem(index);
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }

  setActiveItem(activeIndex) {
    this.navItems.forEach((item, index) => {
      item.classList.toggle('active', index === activeIndex);
    });
    
    this.centerActiveItemOnMobile();
  }

  centerActiveItemOnMobile() {
    if (window.innerWidth > 767) return;
    
    const activeItem = this.querySelector('.q_pageBox-box > span.active');
    const container = this.querySelector('.q_pageBoxOvs');
    
    if (!activeItem || !container) return;
    
    const containerRect = container.getBoundingClientRect();
    const itemRect = activeItem.getBoundingClientRect();
    
    const scrollLeft = itemRect.left - containerRect.left - containerRect.width / 2 + itemRect.width / 2;
    
    container.scrollTo({
      left: container.scrollLeft + scrollLeft,
      behavior: 'smooth'
    });
  }

  getElementTop(element) {
    return Math.round(element.getBoundingClientRect().top + window.scrollY);
  }
}

customElements.define('navigation-fixed', NavigationFixed);

  } catch(e) { console.error(e); }
})();
})();
